import { getRouteUrl as getURL } from '@nackle/service-urls';

export const idURL = getURL( 'ID_PROVIDER' );
export const rosterUrl = getURL( 'ROSTER_PROXY' );
export const cashierUrl = getURL( 'CASHIER' );
export const privacyDownloadUrl = getURL( 'PRIVACY_API_PUBLIC' ) + '/services/v1/files/download'; // /:companyId/:solutionId/:locale
